<template>
  <tbody class="calendar-event-table-row-component">
  <tr :class="`customer-appointment ${eventIsInPast ? 'past' : ''}`">
    <td>
      <a @click="showEventInfo = !showEventInfo" class="show-event-info">
        <i :class="`mdi mdi-${isVisitIcon}`"></i>
        <span :class="eventIsInPast ? 'past' : ''">{{ eventObject.summary }}</span></a>
    </td>
    <td class="compact">{{ momentValue(eventObject.time_start) }}</td>
    <td class="text-right compact">
      <div class="btn-group">
        <button type="button"
                class="btn btn-default btn-sm dropdown-toggle customer-appointment-menu-button"
                data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
          <i class="mdi mdi-dots-vertical"></i>
        </button>
        <ul class="dropdown-menu pull-right" role="menu">
          <li>
            <a title="Wijzigen" class="customer-appointment-edit-button" @click="showEditModal(eventObject.event_type)">
              <i class="mdi mdi-pencil"></i> Wijzigen</a>
          </li>
          <li>
            <a-popconfirm
                title="Weet je zeker dat je deze afspraak wilt verwijderen?"
                ok-text="Ja"
                cancel-text="Nee"
                @confirm="deleteEvent">
              <a title="Verwijderen" class="customer-appointment-delete-button">
                <i class="mdi mdi-delete"></i> Verwijderen</a>
            </a-popconfirm>
          </li>
        </ul>
      </div>
    </td>
  </tr>
  <!--  FIXME: not id, but hashedKey via transformer -->
  <tr v-if="showEventInfo" :id="`event-info-${eventObject.id}`">
    <td colspan="6">
      <span v-if="location"><small><strong>Locatie: </strong>{{ location }}</small><br></span>
      <small><strong>Van: </strong>{{ momentValue(eventObject.time_start) }}</small><br>
      <small><strong>Tot: </strong>{{ momentValue(eventObject.time_end) }}</small><br>
      <small><strong>Omschrijving: </strong></small><br>{{
        eventObject.description ? eventObject.description : '-'
      }}<br>

      <!-- TODO: are there any linked events? -->

    </td>
  </tr>

  <a-modal :visible="showEditEventModal" title="Afspraak wijzigen" @cancel="showEditEventModal = false"
           :footer="false" :destroyOnClose="true" class="calendar-event-create-or-edit-modal-component">
    <edit-event-form @updated="handleEventUpdated"
                     @close="showEditEventModal = false"
                     :event="eventObject"></edit-event-form>
  </a-modal>

  <a-modal :visible="showEditAppointmentModal" title="Afspraak wijzigen" @cancel="showEditAppointmentModal = false"
           :footer="false" class="calendar-event-create-or-edit-modal-component">
    <edit-appointment-form @updated="handleAppointmentUpdated"
                           @close="showEditAppointmentModal = false"
                           :appointment="eventObject"></edit-appointment-form>
  </a-modal>

  </tbody>
</template>

<script>
import moment from 'moment';
import calendarEventApi from '~/api/calendar_event';
import appointmentApi from '~/api/online_afspraken_appointment';
import EditEventForm from './CreateOrEditComponent.vue';
import EditAppointmentForm from './CreateOrEditAppointmentComponent';
import {CalendarEventTypeEnum, CalendarEventVisitTypeEnum, DateFormatEnum} from "~/enums";

export default {
  name: "CalendarEventTableRowComponent",
  components: {EditEventForm, EditAppointmentForm},
  props: {
    event: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      eventObject: this.event,
      showEventInfo: false,
      showEditEventModal: false,
      showEditAppointmentModal: false,
    }
  },
  computed: {
    eventIsInPast() {
      return new Date(this.eventObject.time_end) - new Date() < 0;
    },
    isVisitIcon() {
      switch (this.eventObject.is_visit) {
        case CalendarEventVisitTypeEnum.HOME:
          return 'home';
        case CalendarEventVisitTypeEnum.OFFICE:
          return 'domain';
        default:
          return 'map-marker-question';
      }
    },
    location() {
      if (this.eventObject.event_type === "online_afspraken") return false;

      if (this.eventObject.location) {
        return this.eventObject.location;
      } else {
        switch (this.eventObject) {
          case CalendarEventVisitTypeEnum.HOME:
            return 'Bij de klant';
          case CalendarEventVisitTypeEnum.OFFICE:
            return 'Op kantoor';
          default:
            return '-';
        }
      }
    }
  },
  methods: {
    showEditModal(type) {
      if (type === CalendarEventTypeEnum.DOSSIERDATA) this.showEditEventModal = true;
      if (type === CalendarEventTypeEnum.ONLINE_AFSPRAKEN) this.showEditAppointmentModal = true;
    },
    handleEventUpdated(form) {
      Object.assign(this.eventObject, form);
      this.showEditEventModal = false;
      this.$emit('updated');
    },
    handleAppointmentUpdated(form) {
      this.eventObject = form;
      this.showEditAppointmentModal = false;
      this.$emit('updated');
    },
    deleteEvent() {
      if (this.event.event_type === CalendarEventTypeEnum.DOSSIERDATA) {
        calendarEventApi.delete(this.event.id)
            .then(() => this.deleteSucceeded())
            .catch(() => this.deleteFailed());
      } else if (this.event.event_type === CalendarEventTypeEnum.ONLINE_AFSPRAKEN) {
        appointmentApi.delete(this.event.id)
            .then(() => this.deleteSucceeded())
            .catch(() => this.deleteFailed());
      }
    },
    deleteSucceeded() {
      this.$emit('event-deleted');
      this.$notification['success']({message: 'De afspraak is verwijderd.'});
    },
    deleteFailed() {
      this.$notification['error']({message: 'Het is niet gelukt om de afspraak te verwijderen.',});
    },
    momentValue(datetime) {
      return `${moment(datetime).format(DateFormatEnum.DISPLAY_DATE)} ${moment(datetime).format(DateFormatEnum.TIME)}`
    },
  },
}
</script>

<style scoped>
.past {
  color: #a1a1a1;
}

.show-event-info {
  color: -moz-default-color;
}
</style>
